import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface FMR1Fields {
  general_information_name?: string;
  general_information_code?: string;
  general_information_reporting_institution?: string;
  general_information_reporting_entity_code?: string;
  general_information_rbi_regional_office_name?: string;
  general_information_quarter_ended?: string;
  general_information_date_of_report?: string;
  general_information_reporting_frequency?: string;
  general_information_return_version?: string;
  general_information_reporting_period_start_date?: string;
  general_information_number_of_frauds_submitted?: number;
  fraud_entity_type?: string;
  fraud_entity_code?: string;
  fraud_entity_bank_name?: string;
  fraud_number?: string;
  amount_involved?: number;
  frozen_amount?: number;
  branch_code?: string;
  branch_name?: string;
  branch_other_code?: string;
  fraud_perpetrator_status?: string;
  fraud_perpetrator_account_type?: string;
  fraud_perpetrator_account_type_other?: string;
  fraud_perpetrator_industry_sector?: string;
  lender_details_area_of_operation?: string;
  lender_details_area_of_operation_other?: string;
  lender_details_fraud_in_borrowal_account?: string;
  lender_details_banking_structure?: string;
  lender_details_consortium_lead_bank?: string;
  lender_details_consortium_lead_other?: string;
  lender_details_consortium_leader_amount?: number;
  consortium_advance?: number;
  fraud_classification?: string;
  fraud_classification_other?: string;
  fraud_type?: string;
  fraud_type_other?: string;
  is_it_compromised?: string;
  it_compromise_details?: string;
  fraud_occurrence_date?: string;
  fraud_detection_date?: string;
  fraud_classification_date?: string;
  fraud_reported_to_rbi_date?: string;
  fraud_reporting_delay_reason?: string;
  fraud_settlement_date?: string;
  detection_method?: string;
  detection_other_source?: string;
  internal_external_audit_commission_date?: string; //TODO:Clarify no corresponding field name
  internal_external_audit_date?: string;
  audit_type?: string;
  external_auditor_name?: string;
  diverted_amount?: number;
  root_cause_history?: string;
  modus_operandi?: string;
  perpetrators_staff_involvement?: string;
  perpetrators_customers_involvement?: string;
  perpetrators_outsiders_involvement?: string;
  is_fraud_detectable_via_control_return_scrutiny?: string;
  is_information_system_improvement_needed?: string;
  is_inspection_conducted?: string;
  reason_for_non_detection?: string;
  inspection_audit_action_taken?: string;
  is_lea_complaint_lodged?: string;
  lea_office_name?: string;
  lea_complaint_reference_date?: string;
  lea_complaint_present_position?: string;
  lea_complaint_investigation_completion_date?: string;
  lea_complaint_report_submission_date?: string;
  lea_complaint_court_order_date?: string;
  lea_complaint_court_order_details?: string;
  lea_complaint_not_reported_reason?: string;
  recovery_suit_filing_date?: string;
  recovery_suit_present_position?: string;
  is_insurance_claim_lodged?: string;
  insurance_claim_reasons_not_lodged?: string;
  is_internal_investigation_conducted?: string;
  internal_investigation_completion_date?: string;
  is_departmental_enquiry_conducted?: string;
  staff_side_action_present_status?: string;
  avoidance_measures?: string;
  total_amount_recovered?: number;
  amounts_recovered_from_parties?: number;
  amounts_recovered_from_insurance?: number;
  amounts_recovered_other_sources?: number;
  loss_to_bank?: number;
  provision_held?: number;
  written_off_amount?: number;
  is_compromise_settlement_done?: string;
  settlement_amount?: number;
  suggestions_for_rbi?: string;
  other_developments_details?: string;
  is_case_closed?: string;
  case_closure_date?: string;
  scbf_reported?: string;
  scbf_directions?: string;
  scbf_compliance_given_by_bank?: string;
  is_fraud_involved_in_govt_schemes?: string;
  chosen_govt_scheme?: string;
  govt_scheme_info_others?: string;
  is_fraud_part_of_borrower_group?: string;
  chosen_group_name?: string;
  borrower_group_info_others?: string;
  authorised_reporting_official_name?: string;
  authorised_reporting_official_designation?: string;
  authorised_reporting_official_email_id?: string;
  authorised_reporting_official_tel_o_std?: string;
  authorised_reporting_official_tel_r_std?: string;
  authorised_reporting_official_place?: string;
  authorised_reporting_official_date?: string;
  countersigned_by_name?: string;
  countersigned_by_designation?: string;
  countersigned_by_email_id?: string;
  countersigned_by_tel_o_std?: string;
  countersigned_by_tel_r_std?: string;
  countersigned_by_place?: string;
  countersigned_by_date?: string;
}

export type FMR1RowBase = {
  row_id: string;
  sort_order?: number | null;
};

export type ConsortiumInfo = FMR1RowBase & {
  bank_name?: string | null;
  others_specify?: string | null;
  consortium_amount?: number | null;
};

export type StaffAction = FMR1RowBase & {
  sno?: number | null;
  name?: string | null;
  pan?: string | null;
  c_kyc_number?: string | null;
  designation?: string | null;
  type_of_examination?: string | null;
  suspended?: string | null;
  date_of_suspension?: string | null;
  date_of_issue_of_charge_sheet?: string | null;
  date_of_commencement_of_domestic_enquiry?: string | null;
  date_of_completion_of_enquiry?: string | null;
  date_of_issue_of_final_orders?: string | null;
  punishment_awarded?: string | null;
  details_of_prosecution?: string | null;
};

export type AccountDetailsInfo = FMR1RowBase & {
  sno?: number | null;
  row_number?: number | null;
  name_of_account?: string | null;
  type_of_account?: AccountDetailsAccountType | null;
  others_specify?: string | null;
  account_address?: string | null;
  date_of_sanction?: string | null;
  borrowal_account_sr_no?: string | null;
  sanctioned_limit?: number | null;
  balance_outstanding?: number | null;
  pan_of_account?: string | null;
  cin?: string | null;
  legal_entity_identifier?: string | null;
  date_of_npa_if_any?: string | null;
  name_of_account_customer_id?: string | null;
};

export type FraudPerpetratorInfo = FMR1RowBase & {
  sno?: number | null;
  name_of_perpetrator?: string | null;
  perpetrator_address?: string | null;
  status_of_perpetrators?: string | null;
  pan_of_perpetrator?: string | null;
  fraud_perpetrated_account_name?: string | null;
};

export type AccountDirectorInfo = FMR1RowBase & {
  sno?: number | null;
  name_of_account?: string | null;
  sr_no_of_account?: number | null;
  name_of_director_partner?: string | null;
  pan_of_director_partner?: string | null;
  din?: string | null;
  director_partner_address?: string | null;
};

export type AccountAssociateInfo = FMR1RowBase & {
  name_of_account?: string | null;
  sr_no_of_account?: number | null;
  sno?: number | null;
  name_of_associate_concern?: string | null;
  pan_of_associate_concern?: string | null;
  din?: string | null;
  associate_concern_address?: string | null;
};

export type AssociateDirectorInfo = FMR1RowBase & {
  name_of_associate_concern?: string | null;
  sr_no_of_associate_concern?: number | null;
  sno?: number | null;
  name_of_director?: string | null;
  pan?: string | null;
  din?: string | null;
  director_proprietor_address?: string | null;
};

export type CollateralSecurityInfo = FMR1RowBase & {
  sno?: number | null;
  details_of_collateral_security?: string | null;
  value_of_the_security?: number | null;
  date_of_valuation?: string | null;
  whether_valid?: string | null;
  whether_enforceable?: string | null;
  remarks?: string | null;
};

export type ThirdPartServiceProviderInfo = FMR1RowBase & {
  third_party_service_provider?: string | null;
  tpsp_reported_to_iba_or_other_bodies?: string | null;
  tpsp_registration_details?: string | null;
};

export interface FMR1Response {
  fmr1_fields?: FMR1Fields | null;
  consortium_info?: ConsortiumInfo[] | null;
  staff_side_action?: StaffAction[] | null;
  account_details?: AccountDetailsInfo[] | null;
  perpetrator_info?: FraudPerpetratorInfo[] | null;
  account_director_info?: AccountDirectorInfo[] | null;
  associate_concern?: AccountAssociateInfo[] | null;
  associate_director_info?: AssociateDirectorInfo[] | null;
  collateral_info?: CollateralSecurityInfo[] | null;
  tpsp_info?: ThirdPartServiceProviderInfo[] | null;
}

export interface FMR1UpsertRequest {
  fmr_fields?: FMR1Fields | null;
  consortium_info?: ConsortiumInfo[] | null;
  staff_side_action?: StaffAction[] | null;
  account_details?: AccountDetailsInfo[] | null;
  perpetrator_info?: FraudPerpetratorInfo[] | null;
  account_director_info?: AccountDirectorInfo[] | null;
  associate_concern?: AccountAssociateInfo[] | null;
  associate_director_info?: AssociateDirectorInfo[] | null;
  collateral_info?: CollateralSecurityInfo[] | null;
  tpsp_info?: ThirdPartServiceProviderInfo[] | null;
}

export interface FMR1DeleteRequest {
  consortium_info_ids?: string[] | null;
  staff_side_action_ids?: string[] | null;
  account_details_ids?: string[] | null;
  perpetrator_info_ids?: string[] | null;
  account_director_info_ids?: string[] | null;
  associate_concern_ids?: string[] | null;
  associate_director_info_ids?: string[] | null;
  collateral_info_ids?: string[] | null;
  tpsp_info_ids?: string[] | null;
}

export interface UpdateFMR1Request {
  upsert?: FMR1UpsertRequest;
  delete?: FMR1DeleteRequest;
}

export interface RowMeta {
  isDirty?: boolean;
  isAdded?: boolean;
  isDeleted?: boolean;
};

export type ConsortiumInfoRow = ConsortiumInfo & RowMeta;
export type StaffActionRow = StaffAction & RowMeta;
export type AccountDetailsInfoRow = AccountDetailsInfo & RowMeta;

export enum PerpetratorStatus {
  PRINCIPAL = "Principal",
}

export type FraudPerpetratorInfoRow = FraudPerpetratorInfo & RowMeta;

export type AccountDirectorInfoRow = AccountDirectorInfo & RowMeta;

export type AccountAssociateInfoRow = AccountAssociateInfo & RowMeta;

export type AssociateDirectorInfoRow = AssociateDirectorInfo & RowMeta;

export type CollateralSecurityInfoRow = CollateralSecurityInfo & RowMeta;

export type ThirdPartServiceProviderInfoRow = ThirdPartServiceProviderInfo & RowMeta;

export enum YesNo {
  YES = "Yes",
  NO = "No",
}

export enum GovernmentScheme {
  ATAL_PENSION_YOJANA = "Atal Pension Yojana",
  UJALA_YOJNA = "Ujala Yojna",
  CENTRAL_GOVERNMENT_HEALTH_SCHEME = "Central Government Health Scheme",
  DEENDAYAL_DISABLED_REHABILITATION_SCHEME = "Deendayal Disabled Rehabilitation Scheme",
  DEEN_DAYAL_UPADHYAYA_GRAMEEN_KAUSHALYA_YOJANA = "Deen Dayal Upadhyaya Grameen Kaushalya Yojana",
  DIGITAL_INDIA_PROGRAMME = "Digital India Programme",
  GRAMIN_BHANDARAN_YOJANA = "Gramin Bhandaran Yojana",
  PRADHAN_MANTRI_GRAMIN_AWAAS_YOJANA = "Pradhan Mantri Gramin Awaas Yojana",
  PRADHAN_MANTRI_MATRITVA_VANDANA_YOJANA = "Pradhan Mantri Matritva Vandana Yojana",
  INTEGRATED_CHILD_DEVELOPMENT_SERVICES = "Integrated Child Development Services",
  DEEN_DAYAL_UPADHYAYA_ANTYODAYA_YOJANA = "Deen Dayal Upadhyaya Antyodaya Yojana",
  JANANI_SURAKSHA_YOJANA = "Janani Suraksha Yojana",
  JAWAHARLAL_NEHRU_NATIONAL_URBAN_RENEWAL_MISSION_JNNURM = "Jawaharlal Nehru National Urban Renewal Mission (JnNURM)",
  KASTURBA_GANDHI_BALIKA_VIDYALAYA = "Kasturba Gandhi Balika Vidyalaya",
  INSPIRE_PROGRAMME = "INSPIRE Programme",
  KISHORE_VAIGYANIK_PROTSAHAN_YOJANA = "Kishore Vaigyanik Protsahan Yojana",
  LIVESTOCK_INSURANCE_SCHEME = "Livestock Insurance Scheme",
  MAHATMA_GANDHI_NATIONAL_RURAL_EMPLOYMENT_GUARANTEE_ACT = "Mahatma Gandhi National Rural Employment Guarantee Act",
  MEMBERS_OF_PARLIAMENT_LOCAL_AREA_DEVELOPMENT_SCHEME = "Members of Parliament Local Area Development Scheme",
  MIDDAY_MEAL_SCHEME = "Midday Meal Scheme",
  NAMAMI_GANGE_PROGRAMME = "Namami Gange Programme",
  NATIONAL_LITERACY_MISSION_PROGRAMME = "National Literacy Mission Programme",
  NATIONAL_PENSION_SCHEME = "National Pension Scheme",
  NATIONAL_SCHEME_ON_WELFARE_OF_FISHERMEN = "National Scheme on Welfare of Fishermen",
  NATIONAL_SERVICE_SCHEME = "National Service Scheme",
  NATIONAL_SOCIAL_ASSISTANCE_SCHEME = "National Social Assistance Scheme",
  POOLED_FINANCE_DEVELOPMENT_FUND_SCHEME = "Pooled Finance Development Fund Scheme",
  PRADHAN_MANTRI_ADARSH_GRAM_YOJANA = "Pradhan Mantri Adarsh Gram Yojana",
  PRADHAN_MANTRI_KAUSHAL_VIKAS_YOJNA = "Pradhan Mantri Kaushal Vikas Yojna",
  PRADHAN_MANTRI_SURAKSHA_BIMA_YOJANA = "Pradhan Mantri Suraksha Bima Yojana",
  PRADHAN_MANTRI_JEEVAN_JYOTI_BIMA_YOJANA = "Pradhan Mantri Jeevan Jyoti Bima Yojana",
  PRADHAN_MANTRI_JAN_DHAN_YOJANA = "Pradhan Mantri Jan Dhan Yojana",
  PRADHAN_MANTRI_GRAM_SADAK_YOJANA = "Pradhan Mantri Gram Sadak Yojana",
  RAJIV_AWAS_YOJANA = "Rajiv Awas Yojana",
  RAJIV_GANDHI_GRAMEEN_VIDYUTIKARAN_YOJANA = "Rajiv Gandhi Grameen Vidyutikaran Yojana",
  RASHTRIYA_KRISHI_VIKAS_YOJANA = "Rashtriya Krishi Vikas Yojana",
  RASHTRIYA_SWASTHYA_BIMA_YOJANA = "Rashtriya Swasthya Bima Yojana",
  RNTCP = "RNTCP",
  SAKSHAM_OR_RAJIV_GANDHI_SCHEME_FOR_EMPOWERMENT_OF_ADOLESCENT_BOYS = "Saksham or Rajiv Gandhi Scheme for Empowerment of Adolescent Boys",
  SABLA_OR_RAJIV_GANDHI_SCHEME_FOR_EMPOWERMENT_OF_ADOLESCENT_GIRLS = "Sabla or Rajiv Gandhi Scheme for Empowerment of Adolescent Girls",
  SAMPOORNA_GRAMEEN_ROZGAR_YOJANA = "Sampoorna Grameen Rozgar Yojana",
  SWABHIMAN = "Swabhiman",
  SWARNAJAYANTI_GRAM_SWAROZGAR_YOJANA = "Swarnajayanti Gram Swarozgar Yojana",
  SWAVALAMBAN = "Swavalamban",
  UDISHA = "Udisha",
  VOLUNTARY_DISCLOSURE_OF_INCOME_SCHEME = "Voluntary Disclosure of Income Scheme",
  NATIONAL_RURAL_LIVELIHOOD_MISSION_NRLM = "National Rural Livelihood Mission (NRLM)",
  NATIONAL_URBAN_LIVELIHOOD_MISSION_NULM = "National Urban Livelihood Mission (NULM)",
  HRIDAY_HERITAGE_CITY_DEVELOPMENT_AND_AUGMENTATION_YOJANA = "HRIDAY – Heritage City Development and Augmentation Yojana",
  SUKANYA_SAMRIDHI_YOJANA_GIRL_CHILD_PROSPERITY_SCHEME = "Sukanya Samridhi Yojana (Girl Child Prosperity Scheme)",
  SMART_CITIES_MISSION = "Smart Cities Mission",
  AMRUT = "AMRUT",
  PRADHAN_MANTRI_AWAS_YOJANA_PMAY = "Pradhan Mantri Awas Yojana (PMAY)",
  NATIONAL_CHILD_LABOUR_PROJECTS_NCLP = "National Child Labour Projects(NCLP)",
  NATIONAL_CAREER_SERVICE_INDIA_NCS = "National Career Service (India) (NCS)",
  ANTYODAYA_ANNA_YOJANA = "Antyodaya Anna Yojana",
  PRADHAN_MANTRI_KAUSHAL_VIKAS_YOJANA = "Pradhan Mantri Kaushal Vikas Yojana",
  NATIONAL_FOOD_SECURITY_MISSION = "National Food Security Mission",
  PRADHAN_MANTRI_UJJWALA_YOJANA = "Pradhan Mantri Ujjwala Yojana",
  PRADHAN_MANTRI_BHARTIYA_JAN_AUSHADHI_KENDRA_PMBJK = "Pradhan Mantri Bhartiya Jan Aushadhi Kendra (PMBJK)",
  STANDUP_INDIA = "Standup India",
  OTHERS_PLEASE_SPECIFY = "Others(Please specify)",
}

export enum BorrowerGroupName {
  G001 = "ABC Cotspin Pvt. Ltd.",
  G002 = "Abhijeet Group",
  G003 = "Accord Industries",
  G004 = "ACIL Limited",
  G005 = "Actif Corp",
  G006 = "Aditya Polimers and chemicals (india Pvt Ltd)",
  G007 = "Advance Surfactants India Ltd",
  G008 = "Advantage Overseas Ltd",
  G009 = "Agarwal Industries",
  G010 = "AGR Steel Strips Pvt Ltd",
  G011 = "Ahan Apparel P L",
  G012 = "Al Fara'a Infraprojects Pvt Ltd",
  G013 = "Allied Strips",
  G014 = "Ambika International Food Co",
  G015 = "Amira Pure Foods Pvt Ltd",
  G016 = "Amrapali Group",
  G017 = "Amrapali Silicon City Pvt Ltd & Amrapali Infrastructure",
  G018 = "Anil Ltd",
  G019 = "Apex Encon Project Pvt Ltd",
  G020 = "Apple Group",
  G021 = "Aradhya Steel Pvt Ltd",
  G022 = "Ardor International Limited",
  G023 = "Arise India Ltd",
  G024 = "Arshiya Limited (Formerly Arshiya International Limited)",
  G025 = "Arvind Remedies Ltd.",
  G026 = "Ashapura Intimates Fashion Limited",
  G027 = "Asian Ispat FZ LLC",
  G028 = "ASUTI TRADING PRIVATE LIMITED",
  G029 = "Atlas Jewellery Pvt Ltd.",
  G030 = "Auro Gold Jewellery Pvt Ltd",
  G031 = "B P Foods",
  G032 = "Baid Group",
  G033 = "Bankey Behari Exports Ltd",
  G034 = "Bengal India Global Infra",
  G035 = "Best Foods Limited",
  G036 = "Bhadresh Trading Corp Ltd",
  G037 = "Bharat Bomb and Others",
  G038 = "Bharat Papers",
  G039 = "Bhatia Global Trading Limited",
  G040 = "Bimla Maru Fashion",
  G041 = "Biotor Industries Ltd.",
  G042 = "Blossoms Oils & Fats Ltd.",
  G043 = "Blue Bird India",
  G044 = "Brys International Pvt Ltd",
  G045 = "BS Limited",
  G046 = "Calyx Chemical and Pharmaceuticals Ltd",
  G047 = "CBS Steel Pvt Ltd",
  G048 = "Cethar Ltd",
  G049 = "Champion Agro",
  G050 = "Chinku Bhai Patel & Co",
  G051 = "Cinnabar Holdings",
  G052 = "Classic Forex and Consultancy Services Pvt Ltd.",
  G053 = "Coastal Projects Limited",
  G054 = "Cranes Softwares international",
  G055 = "D S Kulkarni Developers",
  G056 = "Data Access India Ltd",
  G057 = "Deccan Chronicle Holdings Ltd. (DCHL)",
  G058 = "Decent Dia Jewels Pvt Ltd",
  G059 = "Dhanlaxmi Solvex",
  G060 = "Dharmapal Iron and Steel Pvt Ltd",
  G061 = "Diamond Hut India Pvt Ltd",
  G062 = "Diamond Power Infrastructure",
  G063 = "Doshion Water Solution Pvt Ltd",
  G064 = "Dr. Datsons Lab",
  G065 = "Dunar Foods",
  G066 = "Duplex Industries Ltd",
  G067 = "Dwarka Dass Seth group",
  G068 = "Educomp Solutions Ltd",
  G069 = "Electrotherm India Ltd.",
  G070 = "EMI Transmission",
  G071 = "Energo Engineering Projects Ltd.",
  G072 = "Entegra Ltd.",
  G073 = "Era Infra Engineering Ltd",
  G074 = "Ess Dee Aliminium Ltd",
  G075 = "Ethnic Tobacco India Ltd",
  G076 = "EXCEL METAL PROCESSORS PRIVATE LIMITED",
  G077 = "Excel Vehicles Private Limited",
  G078 = "F E India",
  G079 = "Fairdeal Supplies Ltd.",
  G080 = "First Leasing Company of India Ltd",
  G081 = "Five Star Marine Exports Pvt Ltd",
  G082 = "Gangotri Enterprises",
  G083 = "Gee Ispat",
  G084 = "Geodesic",
  G085 = "Goel Agrigreen Fields Pvt Ltd.",
  G086 = "Golden Jubilee Hotels",
  G087 = "Gujarat Foils Ltd",
  G088 = "Gupta Coal India Pvt Ltd",
  G089 = "Haldia Coke & Chemical Pvt Ltd",
  G090 = "Hanjer Bio",
  G091 = "Hanung Toys and Textiles",
  G092 = "Helios and Matheson Info Tech",
  G093 = "Hi tech Grain Processing Pvt Ltd",
  G094 = "Hind Agro",
  G095 = "Housing Development and Infrastructure Ltd (HDIL)",
  G096 = "Ind Barath Thermal Power Ltd",
  G097 = "Indian Technomac Company Ltd.",
  G098 = "Indison Agro Food Ltd",
  G099 = "Infitas Energy Solutions Pvt Ltd",
  G100 = "J R Agrotech Pvt Ltd",
  G101 = "Jagat Agro Commodities Pvct Ltd",
  G102 = "Jaihind Projects Limited",
  G103 = "Jain Infraprojects Ltd.",
  G104 = "Jalaram Rice Industries",
  G105 = "Jay Ambe Gowri Chem",
  G106 = "Jay Bharat Textiles and Real Estate",
  G107 = "Jay Polychem India Pvt Ltd",
  G108 = "Jaylon Impex",
  G109 = "Jhelum Infra Projects India",
  G110 = "JKS Constructions P L",
  G111 = "JMD Oils Pvt Ltd",
  G112 = "Jupitar Spun Pipes and Casting Pvt Ltd",
  G113 = "JVL Agro Industries ltd",
  G114 = "Jyoti Power Corporation",
  G115 = "K K Milk Fresh India Ltd",
  G116 = "Kaizen Auto",
  G117 = "Kanishk Gold Pvt Ltd.",
  G118 = "Kemrock Industries",
  G119 = "Keshav Forex",
  G120 = "KGS Sugar and Infra Corporation Ltd",
  G121 = "Khaitan Electricals Pvt Ltd",
  G122 = "Kharkia Steel P L",
  G123 = "Kingfisher Airlines Limited",
  G124 = "KJSL freight movers",
  G125 = "Konaseema",
  G126 = "Krishna Knitwear Tech",
  G127 = "Krishna Stockist",
  G128 = "KSL Industries",
  G129 = "Kudos Chemie Ltd.",
  G130 = "Kwality Dairy Products",
  G131 = "Kyori Oremin Ltd",
  G132 = "Lakhani India Limited",
  G133 = "Lakshmi Energy and Foods Limited",
  G134 = "Lakshmi Precision Screws Ltd",
  G135 = "Lakshmi Solvex",
  G136 = "Leel Electricals Limited",
  G137 = "Leo Meridian Infrastructure Projects & Hotel Ltd.",
  G138 = "Loha Ispaat Ltd",
  G139 = "M. R. Chains P L",
  G140 = "Mahesh Timber Pvt Ltd",
  G141 = "Maheshwary Ispat Ltd.",
  G142 = "Mandhana Industries Ltd.",
  G143 = "Max Flex and imaging systems ltd",
  G144 = "Maxgrow Overseas Ltd",
  G145 = "MBS Jewellers Pvt Ltd",
  G146 = "Mekaster Engineering Ltd",
  G147 = "Metal Closures P L",
  G148 = "Metalman Industries/ Namco Corp",
  G149 = "Metaphor Exports",
  G150 = "Mohan Gems and Jewels Pvt Ltd.",
  G151 = "Moser Baer India Limited",
  G152 = "Motis Export",
  G153 = "MVL / Noesis",
  G154 = "Naftogaz India Pvt Ltd",
  G155 = "Nakoda Ltd.",
  G156 = "Narayan Trading Co/ Narayan Niryat P L",
  G157 = "Nathella Sampath Jewellery Pvt Ltd",
  G158 = "Neo Corp International Ltd",
  G159 = "Neoteric Informatique Ltd",
  G160 = "Network industries Ltd",
  G161 = "New Chennai Township Pvt. Ltd.",
  G162 = "Nimit Steel and Alloys Ltd",
  G163 = "Nirav Modi and Mehul Choksi group of Companies",
  G164 = "Noesis Industries",
  G165 = "Nutrionex Manufactures Ltd",
  G166 = "Oceanic Tropical fruits Pvt Ltd",
  G167 = "Ojjus Fedelity Health Care Pvt Ltd",
  G168 = "Oneworld Industries",
  G169 = "Onus Enterprises Pvt Ltd",
  G170 = "Opto Circuits India Limited",
  G171 = "OSIL Export Ltd",
  G172 = "P and S Jewellery",
  G173 = "Parabolic Drugs Ltd",
  G174 = "Parameswaria Mangalam Steels P Ltd",
  G175 = "Paramshakti Steel Limited",
  G176 = "Parekh Aluminex Ltd.",
  G177 = "Parikh Fabrics Pvt Ltd",
  G178 = "Pars Ram Brothers",
  G179 = "Partha Foils Pvt Ltd",
  G180 = "Phadnis Infrastructure Ltd",
  G181 = "PKS Ltd",
  G182 = "Prabhu Shanti Real Estate Pvt Ltd",
  G183 = "Prakash Steelage Ltd",
  G184 = "Pranav Agro Industries Ltd",
  G185 = "Precision Engineers and Fabricators Pvt Ltd",
  G186 = "Prime Impex/Prime Pulses",
  G187 = "Provogue(India) Ltd.",
  G188 = "PSL LIMITED",
  G189 = "Psons Ltd",
  G190 = "Pune Build Tech Pvt Ltd",
  G191 = "PUNJAB BASMATI RICE LTD",
  G192 = "Pushpak Bullions",
  G193 = "R H Agro Overseas",
  G194 = "R P Basmati Rice",
  G195 = "R P Infosystems Ltd.",
  G196 = "Radikal Foods Ltd",
  G197 = "Rajat Pharma",
  G198 = "Rama Krishna Knitters",
  G199 = "Ramalaxman Boiled Rice",
  G200 = "Ramdev International Ltd",
  G201 = "Ramka Silk House Ltd",
  G202 = "Ramnandi Hotels",
  G203 = "Ranchi Express",
  G204 = "Rashi Steel and Power Limited",
  G205 = "Rave Scan Pvt Ltd",
  G206 = "Reena Tinaaz Pvt Ltd",
  G207 = "REI Agro Ltd.",
  G208 = "Rialto Exim",
  G209 = "Ricoh India P L",
  G210 = "Rishabhdev Technocable Ltd",
  G211 = "Rishi Ganga Power Corporation",
  G212 = "Roselabs Bioscience Ltd",
  G213 = "Rotomac Global Pvt. Ltd.",
  G214 = "Ruchi Soya",
  G215 = "S L Consumer Products Ltd",
  G216 = "S R Foils",
  G217 = "Saber paper Ltd.",
  G218 = "Sahayog Micro Finance",
  G219 = "Sai Infosystems (including Atrium Infocomm & Click Telecomm)",
  G220 = "Samprash Foods Ltd",
  G221 = "Samruddhi Sugars",
  G222 = "Santosh Overseas Ltd",
  G223 = "Saptarshi Hotels Pvt Ltd",
  G224 = "Sarda Agro Oils Ltd",
  G225 = "SEL Textile Ltd.",
  G226 = "Servalakshmi Paper Limited",
  G227 = "Sevomax India Pvt Ltd.",
  G228 = "SEW LSY High ways",
  G229 = "Shamken Group",
  G230 = "Sharon Biomedicine",
  G231 = "Sharp Corp Limited",
  G232 = "Shivagan Patel Group",
  G233 = "Shivek Labs",
  G234 = "Shiv-Vani Oii, Gas and Energy Ltd - SVOGL Oil",
  G235 = "Shree Ganesh Jewellery House India Ltd.",
  G236 = "Shree Rajmahal Jewellers",
  G237 = "Shree Saraiwwalaa Agrr Refineries Ltd",
  G238 = "Shree Shiv Parwati Shakar Karkhana Ltd",
  G239 = "Shree Shyam Pulp & Board Mills Ltd.",
  G240 = "Shrenuj and Company Ltd",
  G241 = "Shri Lakshmi Cotsyn Limited",
  G242 = "Shri Vishnu Overseas",
  G243 = "Siddhi Vinayak Logistics Ltd.",
  G244 = "Sikkim Ferro Alloys Ltd.",
  G245 = "Simmitronic Semiconductors",
  G246 = "SLO Industries Ltd.",
  G247 = "Soni Ispat Ltd",
  G248 = "Spanco Limited",
  G249 = "SPS Steels Rolling Mills Ltd. & BIGIL",
  G250 = "Sri Sai Sindhu Industries",
  G251 = "Srijan & Govt. accounts Bhagalpur, Bihar",
  G252 = "Srinivasan Health and Educational Trust",
  G253 = "SRS Group Ltd",
  G254 = "SSK Trading and Bansal Diamonds",
  G255 = "Star Agro Marine Exports",
  G256 = "STCL",
  G257 = "Steel Hypermart India Pvt Ltd",
  G258 = "Sterling Biotech Ltd",
  G259 = "Subhiksha Trading Services Ltd.",
  G260 = "Sudalagunta Sugars",
  G261 = "Sudar Industries",
  G262 = "Sukam Power",
  G263 = "Sunil Hi-Tech Engineers Ltd",
  G264 = "SunStar Overseas Ltd",
  G265 = "SUPAMA TRADING PRIVATE LIMITED",
  G266 = "Super Multi Color Printers Pvt Ltd",
  G267 = "Supreme Alloys",
  G268 = "Supreme Tex mart",
  G269 = "Surya Exim Ltd",
  G270 = "Surya Pharmaceutical Ltd.",
  G271 = "SURYA Shree Cashew Products",
  G272 = "Surya Vinayaka Industries Ltd. (SVIL)",
  G273 = "Tara Chand Rice Mills Pvt Ltd",
  G274 = "Tara Corporation Ltd(Tara Health Fruits)",
  G275 = "Tayal Group",
  G276 = "Tenet Exim Pvt Ltd",
  G277 = "The Laxmipathi Balaji Sugar and Distilleries P Ltd",
  G278 = "TIRUPATI BUILDINGS & OFFICES PRIVATE LIMITED",
  G279 = "Tiwari Group",
  G280 = "Topworth Steels and Power Pvt Ltd.",
  G281 = "Totem Infrastructure Ltd.",
  G282 = "Transstroy India Ltd.",
  G283 = "Tulsi Extrusion Pvt. Ltd.",
  G284 = "unique infraventure",
  G285 = "United Cold Chains and Processing Ltd",
  G286 = "Unity Infra Projects",
  G287 = "Usher Agro Ltd.",
  G288 = "Valecha Engineering Ltd",
  G289 = "Vardhman Roofing",
  G290 = "Varia Engineering Works",
  G291 = "Varron Aluminium Pvt. Ltd.",
  G292 = "Varun Industries Ltd",
  G293 = "Vayam Technologies",
  G294 = "Vedika Nut Craft",
  G295 = "Venkateshwara Logistics PL",
  G296 = "VHCL Industries",
  G297 = "Vibha Agrotech Ltd",
  G298 = "Vikas Smelters and Alloys",
  G299 = "Vimal Oil and Foods",
  G300 = "Vinayaka Paper and boards Ltd",
  G301 = "Vindhyavasini Group of Companies",
  G302 = "Visa Power Ltd (Visa Group)",
  G303 = "VMC Syatems Ltd.",
  G304 = "VNR Infrastructures Ltd.",
  G305 = "VSP Udyog pvt ltd",
  G306 = "Winsome Diamond & Jewellery Ltd. (WDJL)",
  G307 = "Winwind Power Energy Pvt Ltd",
  G308 = "Woolways India Limited",
  G309 = "World wide traders and Jasco International",
  G310 = "Worldstar Fabrics LLP",
  G311 = "Xenitis infotech",
  G312 = "Yuvaraj Power Projects",
  G313 = "Zenica cars india Pvt Ltd",
  G314 = "Zoom Developers Ltd.",
  G315 = "Zylog Systems",
  OTHERS_PLEASE_SPECIFY = "Others (Please Specify)",
}


export enum EntityType {
  COMMERCIAL_BANKS_AIFIS = "1. Commercial banks, AIFIs",
  URBAN_COOPERATIVE_BANKS = "2. Urban Cooperative Banks",
  NON_BANKING_FINANCIAL_COMPANIES = "3. Non-Banking Financial Companies",
}

export enum AccountType {
  CORPORATE = "1. Corporate",
  INDIVIDUALS_HUF = "2. Individuals/HUF",
  SOLE_PROPRIETORSHIP = "3. Sole proprietorship",
  PARTNERSHIP_FIRM = "4. Partnership firm",
  LIMITED_LIABILITY_PARTNERSHIP = "5. Limited Liability Partnership firm",
  SOCIETY_NON_PROFIT = "6. Society/non-profit organisations (including NGOs)",
  TRUST = "7. Trust",
  OTHERS = "8. Others (Please specify)",
}

export enum AccountDetailsAccountType {
  TERM_LOAN = "1. Term Loan",
  CASH_CREDIT_WC = "2. Cash Credit/WC",
  BANK_GUARANTEE = "3. Bank Guarantee",
  LETTERS_OF_CREDIT = "4. LCs etc",
  OTHERS = "5. Others (Please Specify)",
}

export enum BankingStructure {
  CONSORTIUM = "Consortium",
  MULTIPLE_BANKING_ARRANGEMENT = "Multiple Banking Arrangement (MBA)",
  SOLE_BANKING = "Sole banking",
}

export enum FraudClass {
  MISAPPROPRIATION_AND_BREACH_OF_TRUST = "1. Misappropriation of funds and criminal breach of trust",
  FRAUDULENT_ENCASHMENT_FORGED_INSTRUMENTS = "2. Fraudulent encashment through forged instruments",
  MANIPULATION_OF_ACCOUNTS_AND_PROPERTY = "3. Manipulation of books of accounts or through fictitious accounts, and conversion of property",
  CHEATING_AND_IMPERSONATION = "4. Cheating by concealment of facts with the intention to deceive any person and cheating by impersonation",
  FORGERY_TO_COMMIT_FRAUD = "5. Forgery with the intention to commit fraud by making any false documents/electronic records",
  WILFUL_DESTRUCTION_OR_ALTERATION_OF_RECORDS = "6. Wilful falsification, destruction, alteration, mutilations of any book, electronic record, paper, writing, valuable security or account with intent to defraud",
  FRAUDULENT_CREDIT_FOR_ILLEGAL_GRATIFICATION = "7. Fraudulent credit facilities extended for illegal gratification",
  CASH_SHORTAGES_DUE_TO_FRAUD = "8. Cash shortages on account of frauds",
  FOREIGN_EXCHANGE_FRAUD = "9. Fraudulent transactions involving foreign exchange",
  DIGITAL_BANKING_FRAUD = "10. Fraudulent electronic banking/ digital payment related transactions",
  OTHERS = "11. Other type of fraudulent activity not covered under any of the above (Please specify)",
}

export enum FraudDetectionMethod {
  CUSTOMER_COMPLAINTS = "1. Customer complaints",
  INTERNAL_INSPECTIONS_AUDITS = "2. Internal Inspections/Audits",
  EXTERNAL_AUDIT = "3. External Audit",
  BANK_MIS = "4. MIS of bank",
  NEWS_AND_MEDIA = "5. News & Media (including social media)",
  CFR_CRILC = "6. CFR/CRILC",
  WHISTLEBLOWER = "7. Whistleblower",
  LAW_ENFORCEMENT_OR_RBI_INTIMATION = "8. Intimation/notice from Law Enforcement Agencies/RBI",
  INTIMATION_FROM_OTHER_BANKS = "9. Intimation from other banks",
  EWS_TRIGGERING = "10. EWS Triggering",
  OTHER_SOURCES = "11. Other sources (Specify)",
}

export enum LEACurrentStatus {
  FIR_REGISTERED = "1. FIR/Police Complaint registered",
  UNDER_INVESTIGATION = "2. Under investigation by CBI/Police",
  CHARGE_SHEETED = "3. Charge-sheeted",
  COURT_CASE_UNDER_PROCESS = "4. Court Case under process",
  VERDICT_ACQUITTED = "5. Verdict given - acquitted",
  VERDICT_CONVICTED = "6. Verdict given - convicted",
}

export enum StaffAccountabilityInvestigationStatus {
  EXAMINATION_UNDER_PROCESS = "1. Examination Under Process",
  NO_STAFF_ACCOUNTABILITY = "2. No Staff accountability",
  EXAMINATION_COMPLETED_DETAILS_PROVIDED = "3. Examination completed and staff details given in Sheet 2",
}

/** String values must match backend enum exactly (Pydantic validation on upsert). */
export enum AreaOfOperation {
  ADVANCES_AGRICULTURE = "Advances-Agriculture",
  ADVANCES_BILLS = "Advances-Bills",
  ADVANCES_CASH_CREDIT = "Advances-Cash Credit",
  ADVANCES_GOLD = "Advances-against Gold/ Gold Ornament",
  ADVANCES_MSME = "Advances-MSME",
  ADVANCES_VEHICLE = "Advances-Vehicle",
  ADVANCES_HOUSING_PROPERTY = "Advances-Housing Loan/Property",
  ADVANCES_PERSONAL_LOANS = "Advances-Personal Loans",
  ADVANCES_EDUCATION_LOANS = "Advances-Education Loans",
  ADVANCES_DIGITAL_LENDING = "Advances-Digital Lending (app based)",
  ADVANCES_CREDIT_CARDS_FAKE_DOCS = "Advances-Credit Cards (Using Fake documents)",
  ADVANCES_OTHER_TERM_LOANS = "Advances-Other Term Loans",
  ADVANCES_OTHERS = "Advances-Others (Please Specify)",

  DIGITAL_PAYMENTS_CREDIT_CARDS = "Digital Payments-Credit cards",
  DIGITAL_PAYMENTS_DEBIT_ATM_CARDS = "Digital Payments-Debit/ATM Cards",
  DIGITAL_PAYMENTS_INTERNET_BANKING = "Digital Payments-Internet Banking",
  DIGITAL_PAYMENTS_UPI = "Digital Payments-UPI",
  DIGITAL_PAYMENTS_WALLET_PREPAID = "Digital Payments-Wallet/ Prepaid cards",
  DIGITAL_PAYMENTS_IMPS_NEFT_RTGS = "Digital Payments-IMPS/NEFT/RTGS",
  DIGITAL_PAYMENTS_AEPS = "Digital Payments-AEPS/Other Aadhaar related frauds",
  DIGITAL_PAYMENTS_USSD = "Digital Payments-USSD",
  DIGITAL_PAYMENTS_OTHERS = "Digital Payments-Other (Please Specify)",

  CASH_SHORTAGE = "Cash Shortage",
  CHEQUES_DEMAND_DRAFTS = "Cheques/demand drafts",
  CLEARING_OPERATIONS = "Clearing operations",

  DEPOSITS_CURRENT = "Deposits-Current",
  DEPOSITS_SAVINGS = "Deposits-Savings",
  DEPOSITS_TERM = "Deposits-Term",

  FOREIGN_EXCHANGE_TRANSACTIONS = "Foreign exchange transactions",
  INTERNAL_ACCOUNTS = "Internal accounts",

  OFF_BALANCE_LETTERS_OF_CREDIT = "Off-balance sheet -Letters of credit",
  OFF_BALANCE_LOU = "Off-balance sheet -LoU",
  OFF_BALANCE_BGS = "Off-balance sheet -BGs",
  OFF_BALANCE_OTHERS = "Off-balance sheet - Others (Please specify)",

  OTHERS = "Others",
}

/** Prior `AreaOfOperation` spellings → current API strings (upsert validation). */
const LENDER_DETAILS_AREA_OF_OPERATION_LEGACY_TO_API: Record<string, string> = {
  "Advances-Against Gold/Gold Ornament": AreaOfOperation.ADVANCES_GOLD,
  "Advances-Digital Lending (App-based)": AreaOfOperation.ADVANCES_DIGITAL_LENDING,
  "Advances-Credit cards (Using fake documents)": AreaOfOperation.ADVANCES_CREDIT_CARDS_FAKE_DOCS,
  "Advances-Other term loans": AreaOfOperation.ADVANCES_OTHER_TERM_LOANS,
  "Advances-Other (Please specify)": AreaOfOperation.ADVANCES_OTHERS,
  "Digital Payments-Debit/ATM cards": AreaOfOperation.DIGITAL_PAYMENTS_DEBIT_ATM_CARDS,
  "Digital Payments-Internet banking": AreaOfOperation.DIGITAL_PAYMENTS_INTERNET_BANKING,
  "Digital Payments-Wallet/Prepaid cards": AreaOfOperation.DIGITAL_PAYMENTS_WALLET_PREPAID,
  "Digital Payments-Other (Please specify)": AreaOfOperation.DIGITAL_PAYMENTS_OTHERS,
  "Cash shortage": AreaOfOperation.CASH_SHORTAGE,
  "Cheques/Demand drafts": AreaOfOperation.CHEQUES_DEMAND_DRAFTS,
  "Off-balance sheet - Letters of credit": AreaOfOperation.OFF_BALANCE_LETTERS_OF_CREDIT,
  "Off-balance sheet - LoU": AreaOfOperation.OFF_BALANCE_LOU,
  "Off-balance sheet - BGs": AreaOfOperation.OFF_BALANCE_BGS,
  "Off-balance sheet - Other (Please specify)": AreaOfOperation.OFF_BALANCE_OTHERS,
  "Other": AreaOfOperation.OTHERS,
};

export function normalizeLenderDetailsAreaOfOperationForApi(value: string | undefined | null): string | undefined | null {
  if (value == null || value === "") return value;
  return LENDER_DETAILS_AREA_OF_OPERATION_LEGACY_TO_API[value] ?? value;
}

export enum IndustryDivision {
  DIV_01 = "Division 01 Crop and animal production, hunting and related service activities",
  DIV_02 = "Division 02 Forestry and logging",
  DIV_03 = "Division 03 Fishing and aquaculture",

  DIV_05 = "Division 05 Mining of coal and lignite",
  DIV_06 = "Division 06 Extraction of crude petroleum and natural gas",
  DIV_07 = "Division 07 Mining of metal ores",
  DIV_08 = "Division 08 Other mining and quarrying",
  DIV_09 = "Division 09 Mining support service activities",

  DIV_10 = "Division 10 Manufacture of food products",
  DIV_11 = "Division 11 Manufacture of beverages",
  DIV_12 = "Division 12 Manufacture of tobacco products",
  DIV_13 = "Division 13 Manufacture of textiles",
  DIV_14 = "Division 14 Manufacture of wearing apparel",
  DIV_15 = "Division 15 Manufacture of leather and related products and harness; dressing and dyeing of fur",
  DIV_16 = "Division 16 Manufacture of wood and products of wood and cork, except furniture",
  DIV_17 = "Division 17 Manufacture of paper and paper products",
  DIV_18 = "Division 18 Printing and reproduction of recorded media",
  DIV_19 = "Division 19 Manufacture of coke and refined petroleum products",
  DIV_20 = "Division 20 Manufacture of chemicals and chemical products and synthetic rubber in primary forms",
  DIV_21 = "Division 21 Manufacture of pharmaceuticals, medicinal chemical and botanical products",
  DIV_22 = "Division 22 Manufacture of rubber and plastics products",
  DIV_23 = "Division 23 Manufacture of other non-metallic mineral products",
  DIV_24 = "Division 24 Manufacture of basic metals",
  DIV_25 = "Division 25 Manufacture of fabricated metal products, except machinery and equipment",
  DIV_26 = "Division 26 Manufacture of computer, electronic and optical products",
  DIV_27 = "Division 27 Manufacture of electrical equipment",
  DIV_28 = "Division 28 Manufacture of machinery and equipment n.e.c.",
  DIV_29 = "Division 29 Manufacture of motor vehicles, trailers and semi-trailers",
  DIV_30 = "Division 30 Manufacture of other transport equipment",
  DIV_31 = "Division 31 Manufacture of furniture",
  DIV_32 = "Division 32 Other manufacturing",
  DIV_33 = "Division 33 Repair and installation of machinery and equipment",

  DIV_35 = "Division 35 Electricity, gas, steam and air conditioning supply",

  DIV_36 = "Division 36 Water collection, treatment and supply",
  DIV_37 = "Division 37 Sewerage",
  DIV_38 = "Division 38 Waste collection, treatment and disposal activities; materials recovery",
  DIV_39 = "Division 39 Remediation activities and other waste management services",

  DIV_41 = "Division 41 Construction of buildings",
  DIV_42 = "Division 42 Civil engineering",
  DIV_43 = "Division 43 Specialized construction activities",

  DIV_45 = "Division 45 Wholesale and retail trade and repair of motor vehicles and motorcycles",
  DIV_46 = "Division 46 Wholesale trade, except of motor vehicles and motorcycles",
  DIV_47 = "Division 47 Retail trade, except of motor vehicles and motorcycles",

  DIV_49 = "Division 49 Land transport and transport via pipelines",
  DIV_50 = "Division 50 Water transport",
  DIV_51 = "Division 51 Air transport",
  DIV_52 = "Division 52 Warehousing and support activities for transportation",
  DIV_53 = "Division 53 Postal and courier activities",

  DIV_55 = "Division 55 Accommodation",
  DIV_56 = "Division 56 Food and beverage service activities",

  DIV_58 = "Division 58 Publishing activities",
  DIV_59 = "Division 59 Motion picture, video and television programme production, sound recording and music publishing activities",
  DIV_60 = "Division 60 Broadcasting and programming activities",
  DIV_61 = "Division 61 Telecommunications",
  DIV_62 = "Division 62 Computer programming, consultancy and related activities",
  DIV_63 = "Division 63 Information service activities",

  DIV_64 = "Division 64 Financial service activities, except insurance and pension funding",
  DIV_65 = "Division 65 Insurance, reinsurance and pension funding, except compulsory social security",
  DIV_66 = "Division 66 Other financial activities",

  DIV_68 = "Division 68 Real estate activities",

  DIV_69 = "Division 69 Legal and accounting activities",
  DIV_70 = "Division 70 Activities of head offices; management consultancy activities",
  DIV_71 = "Division 71 Architecture and engineering activities; technical testing and analysis",
  DIV_72 = "Division 72 Scientific research and development",
  DIV_73 = "Division 73 Advertising and market research",
  DIV_74 = "Division 74 Other professional, scientific and technical activities",
  DIV_75 = "Division 75 Veterinary activities",

  DIV_77 = "Division 77 Rental and leasing activities",
  DIV_78 = "Division 78 Employment activities",
  DIV_79 = "Division 79 Travel agency, tour operator and other reservation service activities",
  DIV_80 = "Division 80 Security and investigation activities",
  DIV_81 = "Division 81 Services to buildings and landscape activities",
  DIV_82 = "Division 82 Office administrative, office support and other business support activities",

  DIV_84 = "Division 84 Public administration and defence; compulsory social security",

  DIV_85 = "Division 85 Education",

  DIV_86 = "Division 86 Human health activities",
  DIV_87 = "Division 87 Residential care activities",
  DIV_88 = "Division 88 Social work activities without accommodation",

  DIV_90 = "Division 90 Creative, arts and entertainment activities",
  DIV_91 = "Division 91 Libraries, archives, museums and other cultural activities",
  DIV_92 = "Division 92 Gambling and betting activities",
  DIV_93 = "Division 93 Sports activities and amusement and recreation activities",

  DIV_94 = "Division 94 Activities of membership organizations",
  DIV_95 = "Division 95 Repair of computers and personal and household goods",
  DIV_96 = "Division 96 Other personal service activities",

  DIV_97 = "Division 97 Activities of households as employers of domestic personnel",
  DIV_98 = "Division 98 Undifferentiated goods- and services-producing activities of private households for own use",

  DIV_99 = "Division 99 Activities of extraterritorial organizations and bodies",
}

export enum FraudTypes {
  COLLATERAL = "Collateral (Fake title deeds, spurious gold and/or its appraisal, FDRs, Bank Guarantees, Multiple mortgages)",
  DOCUMENTS = "Documents (Fake invoices, LCs, transport documents, shipping bills, warehouse receipts, creation of charge in RC books; etc)",
  FINANCIAL_STATEMENTS = "Financial statements (Stock statements, inventory, debtors/creditors/receivables statements, fabricated balance sheets, manipulation of accounts etc)",
  RELATED_PARTY_TRANSACTIONS = "Related Party transactions (Round tripping of funds, fake sales and purchases to inflate turnover)",
  CLANDESTINE_SALE_OF_SECURITY = "Clandestine sale of hypothecated/mortgaged security (Stocks, securities, machineries and equipment, vehicles, immovable property)",
  REGULATORY_VIOLATIONS = "Violations of FEMA / PMLA / Illegal claim of Input Credit in GST etc",
  NON_RESIDENT_ACCOUNTS = "Non-resident accounts",
  FAKE_KYC = "Fake KYC",
  OVERVALUATION_BY_THIRD_PARTY = "Overvaluation/Misrepresentation by Third Party Entities",

  CASH_SHORTAGE_COLLECTION = "Cash Shortage-Cash Collection",
  CASH_SHORTAGE_EMBEZZLEMENT = "Cash Shortage-Embezzlement",
  CASH_SHORTAGE_MANIPULATION = "Cash Shortage-Manipulation",
  CASH_SHORTAGE_CURRENCY_CHEST = "Cash Shortage-Currency Chest",

  FRAUDULENT_CHEQUE_ENCASHMENT = "Cheques/demand drafts-Fraudulent encashment",
  CLONED_OR_FORGED_CHEQUES = "Cheques/demand drafts-Cloned/ forged cheques",
  DEMAND_DRAFT_FRAUD = "Cheques/demand drafts-Demand drafts",

  NON_ROUTING_OF_TRANSACTIONS = "Routing business transactions outside consortium/Non- routing through TRA & CC accounts",

  ACCOUNT_HACKING = "Account Hacking / Compromise / Identity theft",
  PHISHING = "Phishing",
  VISHING = "Vishing",
  SMISHING = "Smishing",
  REMOTE_DEVICE_CAPTURE = "Remote Capture of Device",
  LOST_OR_STOLEN_DEVICE = "Lost / Stolen Device / Instrument",
  CARD_SKIMMING = "Card Skimming",
  SIM_SWAP = "SIM Swap",
  WEBSITE_CLONING = "Website Cloning / Fraudulent Link",
  FRAUDULENT_APP = "Fraudulent App",

  PAYMENT_FORGERY = "Forgery / Modification of Payment",
  COLLECT_PAYMENT_REQUEST = "Collect Payment Request",
  MERCHANT_COLLUSION = "Merchant Collusion",
  NEW_DIGITAL_FRAUD = "New type of digital frauds",

  OTHERS = "Others (Please Specify)",
}

const FMR1ActionsAPI = {
  get: async (case_id: string): Promise<FMR1Response> => {
    const response: AxiosResponse<FMR1Response> = await axiosInstance.get(
      `v2/cases/${case_id}/reports/fmr1`
    );
    return response.data;
  },

  download: async (case_id: string): Promise<Blob> => {
  const response = await axiosInstance.get(
    `v2/cases/${case_id}/reports/fmr1/downloads`,
    {
      responseType: "blob",
    }
  );

  return response.data;
  },

  upsert: async (
    case_id: string,
    request: UpdateFMR1Request
  ): Promise<MessageResponse> => {
    const response: AxiosResponse<MessageResponse> = await axiosInstance.put(
      `v2/cases/${case_id}/reports/fmr1`,
      request
    );
    return response.data;
  },
};

export default FMR1ActionsAPI;
